import { render, staticRenderFns } from "./RequestShortlist.vue?vue&type=template&id=75e22737"
import script from "./RequestShortlist.vue?vue&type=script&lang=js"
export * from "./RequestShortlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports